// src/utils/heroHeaderScripts.js

export const initHeroHeaderScripts = () => {
  // Mobile menu toggle
  const mobileNavToggle = document.querySelector(".mobile-nav-toggle");
  const navmenu = document.querySelector(".hero-header .navmenu ul");
  const navLinks = document.querySelectorAll(".hero-header .navmenu a");

  if (mobileNavToggle) {
    mobileNavToggle.addEventListener("click", () => {
      navmenu.style.display =
        navmenu.style.display === "flex" ? "none" : "flex";
    });

    // Close menu when link is clicked
    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        navmenu.style.display = "none";
      });
    });
  }

  // Scroll top button
  const scrollTop = document.querySelector(".scroll-top");
  const preloader = document.querySelector("#preloader");

  if (preloader) {
    window.addEventListener("load", () => {
      preloader.style.display = "none";
    });
  }

  window.addEventListener("scroll", () => {
    if (scrollTop) {
      if (window.scrollY > 100) {
        scrollTop.classList.add("active");
      } else {
        scrollTop.classList.remove("active");
      }
    }
  });

  if (scrollTop) {
    scrollTop.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  // Set active nav link on scroll
  const sections = document.querySelectorAll("section[id]");
  const navItems = document.querySelectorAll(".hero-header .navmenu a");

  const makeLinksActive = () => {
    let current = "";

    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      if (window.scrollY >= sectionTop - 200) {
        current = section.getAttribute("id");
      }
    });

    navItems.forEach((link) => {
      link.classList.remove("active");
      if (link.getAttribute("href").slice(1) === current) {
        link.classList.add("active");
      }
    });
  };

  window.addEventListener("scroll", makeLinksActive);

  return () => {
    if (mobileNavToggle) {
      mobileNavToggle.removeEventListener("click", null);
    }
    window.removeEventListener("scroll", makeLinksActive);
  };
};
